import * as React from 'react';
import { Avatar, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { VirtualCatalogLeagueDto } from '../../models/dtos/VirtualSportsCatalogDto';

export default function VirtualLeaguesTable(props: {
    leagues: VirtualCatalogLeagueDto[];
    onViewMatches: (league: VirtualCatalogLeagueDto) => void;
    onLeagueClick?: (league: VirtualCatalogLeagueDto) => void;
}) {
    if (props.leagues.length === 0) {
        return <Typography color="text.secondary">No leagues found.</Typography>;
    }

    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>League</TableCell>
                        <TableCell>Sport</TableCell>
                        <TableCell align="right">Matches</TableCell>
                        <TableCell align="right">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.leagues.map(league => (
                        <TableRow
                            key={league.id}
                            hover
                            onClick={() => league.sync_id && props.onLeagueClick?.(league)}
                            sx={league.sync_id && props.onLeagueClick ? { cursor: 'pointer' } : undefined}
                        >
                            <TableCell>
                                <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <Avatar src={league.photo_url ?? undefined} sx={{ width: 32, height: 32 }}>
                                        {league.name.slice(0, 1)}
                                    </Avatar>
                                    <span>
                                        <Typography variant="body2">{league.name}</Typography>
                                        <Typography variant="caption" color="text.secondary">ID {league.id}</Typography>
                                    </span>
                                </span>
                            </TableCell>
                            <TableCell>{league.sport_name}</TableCell>
                            <TableCell align="right">{league.match_count}</TableCell>
                            <TableCell align="right">
                                <Button size="small" onClick={event => { event.stopPropagation(); props.onViewMatches(league); }}>View matches</Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
